import React from 'react';
import ReactGA from "react-ga4";
import ConModalV2 from './ConModalV2.js';
import { attachPortraitFrame } from './vehicle-test/portrait-frame.js';

class Video extends React.Component {

    constructor(props) {
        super(props);
        this.videoRef = null;
        this.conModalInstance = null;
        this.videoIframeRef = null;
        this.releasePortraitFrame = null;
        this.handleVideoIframeRef = this.handleVideoIframeRef.bind(this);
    }

    handleVideoIframeRef(playerIframe) {
        if (this.releasePortraitFrame) {
            this.releasePortraitFrame();
            this.releasePortraitFrame = null;
        }
        this.videoIframeRef = playerIframe;
        if (playerIframe) {
            this.releasePortraitFrame = attachPortraitFrame(playerIframe);
        }
    }

    componentWillMount() {
        let ga_track_ids = '';
        ga_track_ids = this.props.GATrackingId;

        let GA_trackId = ga_track_ids ? ga_track_ids.split(',') : [];

        var that = this;
        window.addEventListener('message', function (e) {
            try {
                var height = JSON.parse(e.data);
                const activePlayerIframe = that.videoIframeRef || (that.conModalInstance && that.conModalInstance.iframe);
                const isOrientationMessage = height.action === 'portrait_video' || height.action === 'landscape_video';
                if (isOrientationMessage && (!activePlayerIframe || e.source !== activePlayerIframe.contentWindow)) {
                    return;
                }
                const playerContainer = activePlayerIframe && activePlayerIframe.closest('.video-object, .conmodal-player-container');
                                
                if (height.action == 'portrait_video') {
                    if (playerContainer && playerContainer.style.maxWidth === '') {
                        playerContainer.style.maxWidth = '350px';
                        playerContainer.style.aspectRatio = '9/16';
                        playerContainer.style.height = 'auto';
                    }
                } else if (height.action == 'landscape_video') {
                    if (playerContainer) {
                        playerContainer.style.cssText = '';
                    }
                }

                if (isOrientationMessage && typeof that.props.reportVideoOrientation === 'function') {
                    if (height.action === 'portrait_video') {
                        that.props.reportVideoOrientation('P');
                    } else if (height.action === 'landscape_video') {
                        that.props.reportVideoOrientation('L');
                    }
                }
               
                var isVt = (that.props.template && that.props.template.indexOf("VT_") > -1) ||
                           (typeof document !== "undefined" && document.body && document.body.classList.contains("vt-template"));
                if (isVt) {
                    return;
                }

                if (height.body_height < 230)
                    return;

                var elem = document.getElementById('videoIframe');
                if (height.body_height && elem) {
                    elem.style.height = height.body_height + 'px';
                    if (elem.parentElement) {
                        elem.parentElement.classList.remove("only-video");
                    }
                }

                if (height.action == 'vb_active' && elem && elem.parentElement) {
                    elem.parentElement.style.cssText = `height:${height.body_height + "px !important"}; padding-bottom:unset !important`;
                }

                if (height.action == 'video_ga_data' && GA_trackId.length != 0) {

                    const trackingObjects = GA_trackId.map(trackingId => ({ trackingId }));
                    ReactGA.initialize(trackingObjects);

                    let data = height.video_data;
                    if (data.message.action == "media-started") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "start",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })

                    } else if (data.message.action == "media-played") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "play",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-paused") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "stop",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    } else if (data.message.action == "media-completed") {
                        ReactGA.event("flick_GA", {
                            event_action_result: "end",
                            affiliation: "EVS",
                            media_type: "video",
                            item_id: data.message.vehicle_vin ? data.message.vehicle_vin : '',
                            creative_name: data.message.video_title ? data.message.video_title : '',
                        })
                    }
                }
            }
            catch (e) {
                console.log(e)
            }
        });
    }

    isDirectVideo() {
        var src = this.props.videoSrc || '';
        return (src.indexOf('/v.php') !== -1 && src.indexOf('/pt.php') === -1) || this.props.videoOrientation === 'P';
    }

    componentDidMount() {
        if (this.props.videoSrc && !this.isDirectVideo() && this.videoRef) {
            this.mountConModal();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.videoSrc !== this.props.videoSrc || nextProps.videoOrientation !== this.props.videoOrientation) {
            var isNextDirect = ((nextProps.videoSrc || '').indexOf('/v.php') !== -1 && (nextProps.videoSrc || '').indexOf('/pt.php') === -1) || nextProps.videoOrientation === 'P';
            if (!isNextDirect) {
                // ConModalV2 will re-mount in componentDidUpdate
            } else {
                var elem = document.getElementById('videoIframe');
                if (elem && elem.parentElement) {
                    elem.parentElement.classList.add('only-video');
                }
            }
        }
    }

    componentDidUpdate(prevProps) {
        const hasVideoChanged = prevProps.videoSrc !== this.props.videoSrc || prevProps.videoOrientation !== this.props.videoOrientation;
        const playerContainer = this.videoIframeRef ? this.videoIframeRef.parentElement : this.videoRef;
        if (hasVideoChanged && playerContainer) {
            playerContainer.style.cssText = '';
        }
        if (hasVideoChanged || prevProps.isPlayerPortrait !== this.props.isPlayerPortrait) {
            this.handleVideoIframeRef(this.videoIframeRef);
        }
        if (this.isDirectVideo()) {
            if (this.conModalInstance) {
                this.conModalInstance.destroy();
                this.conModalInstance = null;
            }
        } else if (this.props.videoSrc && (hasVideoChanged || !this.conModalInstance)) {
            this.mountConModal();
        }
    }

    componentWillUnmount() {
        this.handleVideoIframeRef(null);
        if (this.conModalInstance) {
            this.conModalInstance.destroy();
            this.conModalInstance = null;
        }
    }

    mountConModal() {
        if (!this.videoRef || !this.props.videoSrc || this.isDirectVideo()) return;

        if (this.conModalInstance) {
            this.conModalInstance.destroy();
            this.conModalInstance = null;
        }

        this.videoRef.innerHTML = '';

        var iframeUrl = this.props.videoSrc + '&inline_embed=1';

        this.conModalInstance = new ConModalV2({
            iframeUrl: iframeUrl,
            inline: true,
            targetElement: this.videoRef
        });
    }

    render() {
        let props = this.props;
        const isVt = props.template && props.template.startsWith('VT_');
        const shouldUseVtPortraitLayout = isVt && props.isPlayerPortrait;
        let source;
        var referrer = props.videoSrc.substring(props.videoSrc.indexOf('referer=') + 8, props.videoSrc.length);

        let isMobile = false;
        if (/Android|webOS|iPhone|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) ||
            (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
                !(/iPad/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)))) {
            isMobile = true;
        }

        let isLandscape = false;

        if (window.matchMedia("(orientation: landscape)").matches) {
            isLandscape = true;
        }        

        if (referrer) {
            if (
                referrer.includes("media.flickfusion") ||
                document.referrer.includes("media.flickfusion")
            ) {

                source = props.videoSrc.replace(
                    'referer=https://media.flickfusion.net',
                    "referer="
                );

            } else if ((referrer) && (referrer != document.referrer)) {
                source = props.videoSrc + document.referrer;
            } else if (referrer == document.referrer) {
                source = props.videoSrc;
            }
        } else if (!referrer) {
            source = props.videoSrc + document.referrer;
        }

        function checkOrientation() {
            if (document.querySelector('.video-object iframe')) {
                if (isMobile && window.matchMedia('(orientation: landscape)').matches) {
                    document.querySelector('.video-object').style.maxWidth = 'unset';
                    document.querySelector('.video-object').style.aspectRatio = 'unset';
                    document.querySelector('.video-object').style.height = 'unset';
                    document.querySelector('.video-object iframe').contentWindow.postMessage(JSON.stringify({ action: 'landscape_mode', value: true }), '*');
                } else {
                    document.querySelector('.video-object iframe').contentWindow.postMessage(JSON.stringify({ action: 'landscape_mode', value: false }), '*');
                }
            }
        }

        if (props.videoOrientation == 'P') {
            if (!isVt) {
                window.addEventListener('resize', checkOrientation);
                window.addEventListener('load', checkOrientation);
            }
            if (source.indexOf('portrait=true') === -1) {
                source = `${source}&portrait=true`;
            }
            if (isVt && source.indexOf('auto_resize=1') === -1) {
                source = `${source}&auto_resize=1`;
            }
        }
        
        let isEce = '';
        if (props.viPlayer === "1") {
            isEce = 'is_ece ';
            source = props.videoSrc;
        }

        let conModalClass = `conmodal-player-container ${isEce}`.trim();

        return (
            <div>
                {this.isDirectVideo() ? (
                    <div key={props.videoSrc} className={`video-object only-video ${shouldUseVtPortraitLayout ? 'portrait-mode video_portrait' : ''}`.trim()}>
                        <iframe id={'videoIframe'} title="ff_video" frameBorder="0" src={source} scrolling="no"
                            ref={this.handleVideoIframeRef}
                            allowFullScreen="yes" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
                    </div>
                ) : (
                    <div
                        key={props.videoSrc}
                        className={!isMobile ? conModalClass : (!isLandscape ? `${conModalClass} is_mobile is_portrait` : `${conModalClass} is_mobile is_landscape`)}
                        ref={(el) => { this.videoRef = el; }}
                    >
                    </div>
                )}
            </div>
        );
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js